import { Routes } from '@angular/router';
import { AuthGuard } from './shared/guards/auth.guard';
import { PreventAuthAccessGuard } from './shared/guards/prevent-auth-access.guard';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./pages/auth/auth.routes'),
    canActivate: [PreventAuthAccessGuard]
  },
  {
    path: 'auditor',
    loadChildren: () => import('./pages/auditor/auditor.routes'),
    // canActivate: [AuthGuard]
  },
  {
    path: '',
    redirectTo: '/auth/sign-in',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: '/auth/sign-in'
  }
];
